import axios from "axios";
import {message} from "antd";
import store from "store";

export default class AxiosUtil {

    static AxiosRequest = (url: string, queryParam: {}, callback: (s: boolean, d: any) => void) => {

        const login_info = store.get("login_info");
        const access_token = login_info ? login_info.access_token || "" : "";
        axios({
            headers: {"accessToken": access_token},
            method: 'post',
            url: url,
            data: queryParam
        })
            .then((response) => {
                //console.log(response);
                if (response.status === 200) {
                    if (response.data.code === 200) {
                        callback(true, response.data.data);
                    } else if (response.data.code === 601) {
                        message.error({content: response.data.msg, className: 'message_error'});
                        window.location.replace('/#/login');
                        callback(false, []);
                    } else {
                        message.error({content: 'Data Error: ' + response.data.msg, className: 'message_error'});
                        //window.location.replace('/#/login');
                        callback(false, []);
                    }
                } else {
                    message.error({content: 'Response Error: ' + response.statusText, className: 'message_error'});
                    callback(false, []);
                }
                //_this.setState({showLoading: false});
            })
            .catch((error) => {
                console.log('Axios :' + error);
                message.error({content: 'Axios ' + error, className: 'message_error'});
                callback(false, []);
                //_this.setState({showLoading: false});
            });
    }
}